import { cssColors } from "src/styles/css";

export const X_LABEL_COUNT = 5;
export const Y_LABEL_COUNT = 5;
export const CHART_HEIGHT = 312;
export const MIN_CHART_WIDTH = 800;

export const diagramColors = [cssColors.colorUiPrimary, cssColors.colorSoftGreen];
